_getChatBlockedUsersMiddleWare